import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-one-column-title-subtitle',
    templateUrl: './one-column-title-subtitle.component.html',
    styleUrls: ['./one-column-title-subtitle.component.scss']
})
export class OneColumnTitleSubtitleComponent implements OnInit {

    @Input() title: any = '';
    @Input() subtitle: any = '';
    @Input() width: any = 'FULL';

    constructor() { }

    ngOnInit(): void {
    }

}
